import React, { useEffect, useRef, useState } from 'react';
import ActionDialog from 'jd-library/ActionDialog';
import Button from 'jd-library/Button';
import styles from './user_auth.scss';

const ConfirmModal = props => {
    let {type,data, serviceKey, onConfirm, onHidden, index} = props;
    let heading = (type == 'mobile') ? 'SMS OTP Code' : 'Email OTP Code';
    let btnTxt = (type == 'mobile') ? 'Confirm Mobile Number' : 'Confirm Email';
    let subTxt = (type == 'mobile') ? 'Please confirm on sending the SMS OTP code to the following number' : 'Please confirm on emailing the OTP code to the following email';
    const [loader, setLoader] = useState(false);
	return (
		<>
            <ActionDialog
				onHidden={onHidden}
				settings={{
					modalId: 'secondModal',
					variant: 'action'
				}}
				title={heading}
			>
                <div className={styles['confirm-modal']}>
                    <div className={styles['normal-txt']}>{subTxt}</div>
                    <div className={styles['mob-email']}>{data}</div>
                    <Button 
                        size="lg"
                        className='confirm-btn'
                        clickHandler={() => {
                            setLoader(true);
                            onConfirm({
                                type: type,
                                data: data,
                                index,
                                serviceKey: serviceKey
                            });
                        }}
                        showLoader={loader}
                    >
                        {btnTxt}
                    </Button>
                </div>
			</ActionDialog>
        </>
	);
};

export default ConfirmModal;
